import script from "./ClientModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientModal.vue?vue&type=script&setup=true&lang=js"

import "./ClientModal.vue?vue&type=style&index=0&id=d70bef06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d70bef06"]])

export default __exports__